import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { AppSettings, Settings } from 'src/app/app.settings';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BpAddressService } from 'src/app/services/bp-address.service';
import { LocationService } from 'src/app/services/ecommerce/location.service';
import { ErrorManagementService } from 'src/app/services/global/error-management.service';
import { hourIsLowNow } from 'src/app/utils/time-validator.strategy';
import { AddAddressComponent } from '../add-address/add-address.component';
import { DialogCustomComponent } from '../dialog-custom/dialog-custom.component';
import { CompanyService } from 'src/app/services/global/company.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delivery-address',
  templateUrl: './delivery-address.component.html',
  styleUrl: './delivery-address.component.scss',
})
export class DeliveryAddressComponent implements OnInit {
  public settings: Settings;
  obs: Subscription[] = [];

  //ADDRESS
  addressId: any;
  principalAddress = {
    country: null,
    location_one: null,
    location_two: null,
    location_three: '',
    latitude: null,
    longitude: null,
    address: '',
    reference: '',
  };
  principalActive = '1'; //ciudad esta activo o no(eliminado)
  listAddress: any = [];

  addressForm: FormGroup;

  _user: any;
  zoneObjectPrincipal: any;

  company: any

  constructor(
    private companyService: CompanyService,
    public authService: AuthenticationService,
    private addressService: BpAddressService,
    private locationService: LocationService,
    public appSettings: AppSettings,
    private errorService: ErrorManagementService,
    public formBuilder: FormBuilder,
    private matDialogService: MatDialog,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DeliveryAddressComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.addressForm = this.formBuilder.group({
      addressId: [null, Validators.required],
    });
    this.settings = this.appSettings.settings;

    this.obs.push(
      this.companyService.currenCompany.subscribe(res => {
        this.company = res
      })
    )
  }

  ngOnInit(): void {
    this.getListAddress();

    this.obs.push(
      this.authService.currentUser.subscribe(
        (user) => {
          if (user != null) {
            this._user = user.user as any;
            if (this._user) {
              this.principalAddress = {
                country: this._user.bp_countryCode,
                location_one: this._user.bp_locationOneCode,
                location_two: this._user.bp_locationTwoCode,
                location_three: this._user.bp_locationThreeCode,
                latitude: this._user.bp_latitude,
                longitude: this._user.bp_longitude,
                address: this._user.bp_address,
                reference: this._user.bp_reference,
              };
              this.addressId =
                this._user.bp_addressSelected == 0 ||
                this._user.bp_addressSelected == '0'
                  ? '0'
                  : this._user.bp_addressSelected;
              if (this._user.bp_locationZoneId) {
                this.getZonePrincipalById(this._user.bp_locationZoneId);
              }

              this.getActiveCity();
            }
          }
        },
        (error) => {
          this.errorService.getErrorMessage(error);
        }
      )
    );
  }

  //ADDRESS
  getListAddress() {
    this.addressService.getAddresByBpCb().subscribe(data => {
      this.listAddress = data
    }, error => {
      this.errorService.getErrorMessage(error)
    })
  }

  verifyAddress(item: any) {
    if (item != null && item != '0' && item != 0 && item != '') {
      if (item.location_two_active == '0') {
        return;
      }
      if(this.company && this.company.addressType == '1'){
        if (item.locationZoneActive == null || item.locationZoneDelete == '1') {
          let fiD = this.listAddress.findIndex((res:any) => res.id == item.id)
          this.openNewAddress(this.listAddress[fiD])
          this.translate
          .get('TRANSLATE.UPDATE_RESIDENTIAL_AREA')
          .subscribe((translatedMessage) => {
            this.snackBar.open(translatedMessage, '×', {
              panelClass: 'error',
              verticalPosition: 'top',
              duration: 3000,
            });
          });
          return
        } else {
          if (item.locationZoneActive == '2') {
            this.translate
            .get('TRANSLATE.AREA_OUT')
            .subscribe((translatedMessage) => {
              this.snackBar.open(translatedMessage, '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                duration: 3000,
              });
            });
            return
          }
          if (hourIsLowNow(item.locationZoneHourAttention)) {
            this.translate
            .get('TRANSLATE.AREA_NOT_COVERAGE')
            .subscribe((translatedMessage) => {
              this.snackBar.open(translatedMessage, '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                duration: 3000,
              });
            });
            return
          }
        }
      }
    } else {
      if (this.principalActive == '0') {
        return;
      }
      if(this.company && this.company.addressType == '1'){
        if (this.zoneObjectPrincipal == null || this.zoneObjectPrincipal.bp_locationZoneDelete == '1') {
          this.openUpdateAddress()
          this.translate
          .get('TRANSLATE.UPDATE_RESIDENTIAL_AREA')
          .subscribe((translatedMessage) => {
            this.snackBar.open(translatedMessage, '×', {
              panelClass: 'error',
              verticalPosition: 'top',
              duration: 3000,
            });
          });
          return
        } else {
          if (this.zoneObjectPrincipal.active == '2') {
            this.translate
            .get('TRANSLATE.AREA_OUT')
            .subscribe((translatedMessage) => {
              this.snackBar.open(translatedMessage, '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                duration: 3000,
              });
            });
            return
          }
          if (hourIsLowNow(this.zoneObjectPrincipal.hourAttention)) {
            this.translate
            .get('TRANSLATE.AREA_NOT_COVERAGE')
            .subscribe((translatedMessage) => {
              this.snackBar.open(translatedMessage, '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                duration: 3000,
              });
            });
            return
          }
        }
      }
    }

    this.dialogRef.close(item);
  }

  openNewAddress(element: any) {
    let sendAddresPrincipal = {
      id: 0,
      name: 'Principal',
      country_code: this.principalAddress.country,
      location_one_code: this.principalAddress.location_one,
      location_two_code: this.principalAddress.location_two,
      location_three_code: this.principalAddress.location_three,
      latitude: this.principalAddress.latitude,
      longitude: this.principalAddress.longitude,
      address: this.principalAddress.address,
      reference: this.principalAddress.reference,
      locationZoneId: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.id
        : null,
      locationZoneName: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.name
        : null,
      locationZoneActive: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.active
        : null,
      locationZoneMotive: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.motive
        : null,
      locationZoneDelete: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.bp_locationZoneDelete
        : null,
    };
    let editAddressPrincipal = false;
    if (
      !this.principalAddress.country ||
      !this.principalAddress.location_one ||
      !this.principalAddress.location_two ||
      !this.principalAddress.address
    ) {
      editAddressPrincipal = true;
    }

    const dialogRef = this.matDialogService.open(AddAddressComponent, {
      data: !editAddressPrincipal ? element : sendAddresPrincipal,
      width: '700px',
      disableClose: true,
      panelClass: 'address-dialog',
      direction: this.settings.rtl ? 'rtl' : 'ltr',
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('result del', result);
      if (result == 'close' || result == undefined) {
      } else {
        if (result.id == 0) {
          if (result.id == 0) {
            this.onUpdateDataBpOnlyAddress(result);
            this.addressId = '0'; //this.addressForm.get('addressId').setValue('0')
          }
        } else {
          this.addressId = result.id; //this.addressForm.get('addressId').setValue(result.id)
          this.getListAddress();
        }
        //if(element == null){ //aunque edite o es nuevo se tiene que llamar a la tienda para validar
        this.dialogRef.close(result.id == 0 ? '0' : result);
        //}
      }
    });
  }

  openUpdateAddress() {
    let sendAddresPrincipal = {
      id: 0,
      name: 'Principal',
      country_code: this.principalAddress.country,
      location_one_code: this.principalAddress.location_one,
      location_two_code: this.principalAddress.location_two,
      location_three_code: this.principalAddress.location_three,
      latitude: this.principalAddress.latitude,
      longitude: this.principalAddress.longitude,
      address: this.principalAddress.address,
      reference: this.principalAddress.reference,
      locationZoneId: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.id
        : null,
      locationZoneName: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.name
        : null,
      locationZoneActive: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.active
        : null,
      locationZoneMotive: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.motive
        : null,
      locationZoneDelete: this.zoneObjectPrincipal
        ? this.zoneObjectPrincipal.bp_locationZoneDelete
        : null,
    };
    const dialogRef = this.matDialogService.open(AddAddressComponent, {
      data: sendAddresPrincipal,
      width: '700px',
      disableClose: true,
      panelClass: 'address-dialog',
      direction: this.settings.rtl ? 'rtl' : 'ltr',
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('result del', result);
      if (result == 'close' || result == undefined) {
      } else {
        if (result.id == 0) {
          console.log('result del', result);
          this.onUpdateDataBpOnlyAddress(result);
          this.addressId = '0'; //this.addressForm.get('addressId').setValue('0')
          this.getActiveCity();
        }
      }
    });
  }

  openDeleteAddress(ele: any) {
    const dialogRef = this.matDialogService.open(DialogCustomComponent, {
      data: {
        title: 'Eliminar Dirección',
        body: '¿Estas seguro de eliminar esta direccion?',
        no: 'No',
        yes: 'Si',
      },
      width: '400px',
      disableClose: true,
      //panelClass: 'address-dialog',
      //direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'close' || result == undefined) {
      } else {
        if (result == 'yes') {
          this.addressService.deleteAddresByBp(ele.id).subscribe(
            (res) => {
              this.translate
                .get('TRANSLATE.REMOVED_SUCCESSFULLY')
                .subscribe((translatedMessage) => {
                  this.snackBar.open(translatedMessage, '×', {
                    panelClass: 'success',
                    verticalPosition: 'top',
                    duration: 3000,
                  });
                });

              this.addressId = null;
              this.getListAddress();
            },
            (error) => {
              this.snackBar.open(error.error.message, '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                duration: 3000,
              });
            }
          );
        }
      }
    });
  }

  onUpdateDataBpOnlyAddress(result: any) {
    let send = {
      agent: this._user.bp_invite == '1' ? '' : this._user.bp_agent,
      identificationDocument: this._user.bp_identificationDocument,
      email: this._user.email,
      mobile: this._user.bp_mobile,
      phone: this._user.bp_phone,
      address: result.address,
      country: result.country,
      latitude: result.latitude,
      locationZone: result.locationZone,
      location_one: result.location_one,
      location_three: result.location_three,
      location_two: result.location_two,
      longitude: result.longitude,
      reference: result.reference,
    };

    this.authService.updateData(this._user.bp_id, send).subscribe(
      (res) => {
        this.authService.updateCurrentUser(res);
      },
      (error) => {
        this.errorService.getErrorMessage(error);
      }
    );
  }

  getZonePrincipalById(id: any) {
    this.locationService.getZoneServerSideOne(id).subscribe(
      (res) => {
        this.zoneObjectPrincipal = res;
        this.zoneObjectPrincipal['bp_locationZoneDelete'] = this
          .zoneObjectPrincipal.idDelete
          ? this.zoneObjectPrincipal.idDelete
          : this._user.bp_locationZoneDelete;
      },
      (error) => {
        this.errorService.getErrorMessage(error);
      }
    );
  }

  getActiveCity() {
    this.locationService
      .getValidateActiveCity(this._user.bp_locationTwoCode)
      .subscribe(
        (data: any) => {
          if (data != null) {
            this.principalActive = data.active; //viene 5 campos
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  ngOnDestroy() {
    this.obs.forEach((ele) => {
      ele.unsubscribe();
    });
  }
}
